import { SectionTitle } from "@diana-ui/typography";
import styled, { css } from "styled-components";
/**
 * Component Li
 */

export var TabLi = /*#__PURE__*/ styled.li.withConfig({
  displayName: "Tabstyle__TabLi"
})(_ref => {
  var { theme } = _ref;
  return css(
    [
      "box-sizing:border-box;cursor:pointer;list-style:none;display:flex;flex-direction:column;position:relative;text-align:center;margin:0px ",
      ";&:first-child{margin-left:0;}&::last-child{margin-right:0;}&.disabled{cursor:default;}"
    ],
    theme.spaceUnit.xs
  );
});
export var StyledLabel = /*#__PURE__*/ styled(SectionTitle).withConfig({
  displayName: "Tabstyle__StyledLabel"
})(() => css(["white-space:nowrap;"]));
export var TabBorder = /*#__PURE__*/ styled.div.withConfig({
  displayName: "Tabstyle__TabBorder"
})(_ref2 => {
  var { theme } = _ref2;
  return css(
    ["position:absolute;bottom:0;left:0;height:1px;width:100%;background-color:", ";"],
    theme.colors.black
  );
});
